<template>
  <span>
    <v-chip v-if="user.state === 'PENDING'" color="grey" dark>
      {{ $t("admin.user.state.pending") }}
    </v-chip>

    <v-chip v-if="user.state === 'APPROVED'" color="green" dark>
      {{ $t("admin.user.state.approved") }}
    </v-chip>

    <v-chip v-if="user.state === 'REJECTED'" color="red" dark>
      {{ $t("admin.user.state.rejected") }}
    </v-chip>

    <v-chip v-if="user.state === 'STAFF'" color="blue" dark>
      {{ $t("admin.user.state.staff") }}
    </v-chip>
  </span>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
};
</script>
